import {
  trackFindReplaceModalCancelled,
  trackFindReplaceModalOpened,
} from '@/lib/analytics/scribe/ui';
import { atom, useAtom } from 'jotai';
import { useCallback } from 'react';

/*
 * Find Replace Modal state & original text user selected
 */
export const findReplaceModalOpenAtom = atom<boolean>(false);
export const findReplaceOriginalTextAtom = atom<string>('');

export const useFindReplaceStates = () => {
  const [findReplaceModalOpen, setFindReplaceModalOpen] = useAtom(
    findReplaceModalOpenAtom
  );
  const [findReplaceOriginalText, setFindReplaceOriginalText] = useAtom(
    findReplaceOriginalTextAtom
  );

  const toggleFindReplaceModal = useCallback(
    (isOpen: boolean) => {
      setFindReplaceModalOpen(isOpen);
      if (!isOpen) {
        trackFindReplaceModalCancelled();
      }
    },
    [setFindReplaceModalOpen]
  );

  const onFindReplaceClick = useCallback(
    (text: string) => {
      setFindReplaceModalOpen(true);
      setFindReplaceOriginalText(text.trimEnd());
      trackFindReplaceModalOpened();
    },
    [setFindReplaceModalOpen, setFindReplaceOriginalText]
  );

  return {
    findReplaceModalOpen,
    findReplaceOriginalText,
    toggleFindReplaceModal,
    onFindReplaceClick,
  };
};
